import { useEffect, useState } from 'react';
import { getPlaceFromRequest } from '../api';

/**
 * @name useLocationData
 * @description
 * Custom React hook to fetch the user's location from an API on component mount.
 * It returns only the country part of the location data.
 *
 * @returns String A String containing the country name (empty string if unavailable).
 */
export const useLocationData = () => {
    const [userCountry, setUserCountry] = useState<string>('');

    useEffect(() => {
        const getLocation = async () => {
            try {
                const location = await getPlaceFromRequest();
                setUserCountry(location?.place?.country ?? '');
            } catch (error) {
                console.error('Error fetching user location:', error);
            }
        };
        getLocation();
    }, []);

    return userCountry;
};
